export const HOME_URL = '/home';
export const EXAMPLES_URL = '/examples';
export const DOWNLOAD_URL = '/download';
export const PRICING_URL = '/pricing';
export const FAQ_URL = '/faq';
export const DOCS_URL = '/docs';
export const TERMS_URL = '/legal/terms-of-service';
export const PRIVACY_URL = '/legal/privacy-policy';
